import React, { useEffect, useMemo, useCallback } from "react";
import CloseIcon from "../../../../assets/Image/close.png";

const ReusableModal = ({
  show,
  handleClose,
  title,
  children,
  width = "900px",
  height = "auto",
  showCloseButton = true
}) => {

  const handleOutsideClick = useCallback((e) => {
    if (e.target.classList.contains("modal-overlay")) handleClose();
  }, [handleClose]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.body.style.overflow = "auto";
      document.removeEventListener("click", handleOutsideClick);
    }
    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [show, handleOutsideClick]);

  const modalContentStyle = useMemo(() => ({
    borderRadius: "20px",
    overflow: "hidden",
    width,
    height,
    maxWidth: "100%",
    maxHeight: "80%",
    overflowY: "auto",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    position: "relative"
  }), [width, height]);

  if (!show) return null;

  return (
    <div
      className="modal-overlay"
      style={{
        display: "flex",
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      tabIndex="-1"
      role="dialog"
      onClick={handleOutsideClick}
    >
      <div className="modal-content" style={modalContentStyle}>
        <div className="modal-header" style={{
          height: "55px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 16px",
          border: "none",
        }}>
          <h5 className="modal-title" style={{
            fontWeight: "700",
            fontSize: "24px",
            margin: "14px 0 0 0",
            color: "#000000",
            textAlign: "center",
            flex: 1,
          }}>
            {title}
          </h5>
          {showCloseButton && (
            <div style={{ cursor: "pointer", paddingTop: "10px" }}>
              <img src={CloseIcon} alt="Close" width="25" height="25" onClick={handleClose} />
            </div>
          )}
        </div>
        <div className="modal-body" style={{ backgroundColor: "#FFFFFF" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ReusableModal;